import { MakBatValue } from '../../services/msdsCoverpageApi';

interface MakBatTableProps {
    values: MakBatValue[];
    onUpdate: (index: number, field: keyof MakBatValue, value: string) => void;
}

export function MakBatTable({ values, onUpdate }: MakBatTableProps) {
    if (values.length === 0) {
        return (
            <p className="text-sm text-gray-500 italic">
                No ingredients with CAS numbers found. Upload a MSDS PDF to auto-populate.
            </p>
        );
    }

    return (
        <div className="overflow-x-auto">
            <table className="w-full text-sm border-collapse">
                <thead>
                    <tr className="bg-gray-50">
                        <th className="text-left p-2 border-b font-medium">Substance</th>
                        <th className="text-left p-2 border-b font-medium">CAS Nr.</th>
                        <th className="text-left p-2 border-b font-medium">MAK Value</th>
                        <th className="text-left p-2 border-b font-medium">Notation</th>
                        <th className="text-left p-2 border-b font-medium">Source</th>
                    </tr>
                </thead>
                <tbody>
                    {values.map((v, idx) => (
                        <tr key={idx} className="border-b hover:bg-gray-50">
                            <td className="p-2">
                                <input
                                    type="text"
                                    value={v.substance}
                                    onChange={e => onUpdate(idx, 'substance', e.target.value)}
                                    className="w-full px-2 py-1 border rounded text-sm"
                                />
                            </td>
                            <td className="p-2">
                                <span className="text-gray-600 font-mono text-xs">{v.casNumber}</span>
                            </td>
                            <td className="p-2">
                                <input
                                    type="text"
                                    value={v.makValue && v.makUnit ? `${v.makValue} ${v.makUnit}` : ''}
                                    onChange={e => onUpdate(idx, 'makValue', e.target.value)}
                                    placeholder="No Swiss limit"
                                    className="w-full px-2 py-1 border rounded text-sm"
                                />
                            </td>
                            <td className="p-2">
                                <input
                                    type="text"
                                    value={v.notation || ''}
                                    onChange={e => onUpdate(idx, 'notation', e.target.value)}
                                    placeholder="-"
                                    className="w-full px-2 py-1 border rounded text-sm"
                                />
                            </td>
                            <td className="p-2">
                                <span className={`text-xs px-2 py-0.5 rounded-full ${
                                    v.source === 'suva-api' ? 'bg-green-100 text-green-700' :
                                    v.source === 'static' ? 'bg-blue-100 text-blue-700' :
                                    'bg-yellow-100 text-yellow-700'
                                }`}>
                                    {v.source === 'suva-api' ? 'SUVA' :
                                     v.source === 'static' ? 'Cached' :
                                     'Not found'}
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
